import { useBookingsContext } from "../hooks/useBookingsContext"
import HistoryDetail from "../components/HistoryDetail"
import '../styling/history.css'
import { strings } from "../strings"

const YearSummary = ({y}) => {
    const { history } = useBookingsContext()

    return (
        <div className="year-container">
            <h3 className="history-statistics">{strings.history.total} {y}{": "} {history[y].length}</h3>
            {history[y].map(booking => <HistoryDetail key={booking._id} booking={booking} />)}
        </div>
    )
}

const History = () => {

    const { history } = useBookingsContext()

    return (
        <div className="history-container">
            <h2 className="history-title">{strings.history.title}</h2>
            {history && Object.entries(history).map(([y]) => <YearSummary y={y}/>)}
        </div>
    )
}

export default History